<template>
  <v-card>
    <v-card-title :class="textCenter ? 'justify-center' : ''" class="ml-2">Work Experience</v-card-title>

    <ListCard :items='experience' />
  </v-card>
</template>

<script>
import { mdiYoutube, mdiGithub, mdiWeb } from '@mdi/js'
import ListCard from '../ListCard'

export default {
  name: 'WorkExperience',
  components: {
    ListCard
  },
  data(){
    return {
      experience: [
        {
          src: '/img/workExperience/deepinfo.png',
          alt: 'deepinfo',
          name: 'Software Developer | DeepInfo',
          date: '02/2022 - Present',
          summary: '<ul class="pl-2 pr-0 text-left"> \
                      <li>Worked within an agile scrum team, contributing to 100% continuous improvement and devlopyment.</li>\
                      <li>Developed, tested, debugged, and documented Django and FastAPI RESTful APIs.</li>\
                      <li>Code reviews.</li> \
                      <li>Implemented elasticsearch search-after to optimize pagination.</li>\
                    </ul>',
          dialog: false,
          details: false,
          links: [
            {
              icon: mdiWeb,
              href: 'https://www.deepinfo.com/',
              color: 'black'
            }
          ]
        },
        {
          src: '/img/workExperience/tubitak.png',
          alt: 'tubitak',
          name: 'Researcher | TUBİTAK',
          date: '12/2019 - 02/2022',
          summary: '<ul class="pl-2 pr-0 text-left"> \
                      <li>Analyzing and processing text data using Apache Spark</li> \
                      <li>Mentored intern researchers.</li> \
                      <li>Using protractor, built end-to-end testing infrastructure for an Angular project.</li> \
                    </ul>',
          dialog: false,
          details: false,
          links: [
            {
              icon: mdiWeb,
              href: 'https://bilgem.tubitak.gov.tr/en/urunler/cloud-computing-and-big-data-research-laboratory-b3lab',
              color: 'black'
            }
          ]
        },
        {
          src: '/img/workExperience/optiwisdom.png',
          alt: 'optiwisdom',
          name: 'Full Stack Data Scientist | Optiwisdom',
          date: '09/2019 - 12/2019',
          summary: '<ul class="pl-2 pr-0 text-left"> \
                      <li>Scrapping data from various APIs and processing data using pipelines.</li> \
                      <li>Time series data analysis and using machine learning models in time series data.</li> \
                      <li>Using Angular, developed new user‐facing features.</li> \
                      <li>Experienced pair programming.</li> \
                    </ul>'
          ,
          dialog: false,
          details: false,
          links: [
            {
              icon: mdiWeb,
              href: 'https://optiwisdom.com/',
              color: 'black'
            }
          ]
        },
        {
          src: '/img/workExperience/freelance.png',
          alt: 'freelance',
          name: 'Freelance Python Developer | BackupTechnology',
          date: '01/2019 - 09/2019',
          summary: '<ul class="pl-2 pr-0 text-left"> \
                      <li>Using selenium and APIs, fetched data from various social media platforms.</li> \
                      <li>Using YOLO, developed machine learning models that can analyze images from target social media platforms.</li> \
                      <li>Using fastText, developed machine learning models that can classify text data from target social media platforms. Using Python libraries, developed sentiment analysis models.</li> \
                    </ul>',
          dialog: false,
          details: false, // 'We were using Python Scrapy and Selenium when API is not available. For instance, we were scrapping data from Twitter with API but from Instagram and Facebook we used Python Selenium. We used various text sentiment analysis tools such as fasttext, nltk and image processing tools such as YOLO.',
        },
        {
          src: '/img/workExperience/delft.png',
          alt: 'guest researcher',
          name: 'Guest Reasearcher | TU Delft University',
          date: '06/2018 - 09/2018',
          summary: 'We were trying to understand new tool called Apache Arrow and Plasma. I was comparing the latency of various languages (C++, Python, Java) using Apache Arrow Plasma. I was working with Assist. Prof. Zaid Al-Ars.',
          dialog: false,
          details: false,
          links: [
            {
              icon: mdiGithub,
              href: 'https://github.com/osmantamer/arrow-plasma/stargazers',
              color: 'black'
            }
          ]
        },
        {
          src: '/img/workExperience/sehir.png',
          alt: 'teaching assistant',
          name: 'Teaching Assistant | Istanbul Sehir University',
          date: '11/2017 - 05/2019',
          summary: '<ul class="pl-2 pr-0 text-left"> \
                      <li>Teaching Assistant for course EECS 241 - Discrete Math during fall semester in 2017 (Instructor: Prof. Mehmet Akif Eyler).</li> \
                      <li>Teaching Assistant for course ENGR 101 - Introduction to Programming during spring semester in 2018 (Instructor: Assist. Prof. Ali Cakmak).</li> \
                      <li>Teaching Assistant for course CS 351 - Computer Architecture during fall semester in 2018 (Instructor: Assist. Prof. Barış ARSLAN).</li> \
                      <li>Teaching Assistant for course CS 240 - Exploratory Data Analysis during spring semester in 2019 (Instructor: Assist. Prof. Barış ARSLAN).</li> \
                    </ul>',
          dialog: false
        }
      ]
    }
  },
  computed: {
    imgSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 100
        case 'sm': return 125
        case 'md': return 125
        case 'lg': return 125
        case 'xl': return 125
      }
    },
    col() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 4
        case 'md': return 4
        case 'lg': return 4
        case 'xl': return 4
      }
    },
    textCenter() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return false
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
    },
  }
}
</script>

<style>
a {
  text-decoration: none !important;
  font-weight: bold;
}
</style>